import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnalyticsDashboardComponent } from './analytics-dashboard/analytics-dashboard.component';
import { InteractionsMsgComponent } from './interactions-msg/interactions-msg.component';

const routes: Routes = [
  {
    path: 'interactions',
    component: InteractionsMsgComponent,
  },
  {
    path: 'analytics',
    component: AnalyticsDashboardComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
